import { customElement } from 'aurelia-templating';
import { BindingEngine } from 'aurelia-binding';
import { UnconvertedInstrumentsService } from '../../../services/unconverted-instruments-service';
import { CacheService, CustomerService, IApplicationFilter, WidgetBase, property, widget } from '@dynamik/common';
import { UnconvertedInstrumentsViewModel } from '@dynamik/common/clients/transaction-clients';

@customElement('unconverted-instruments-widget')
@widget('Unconverted instruments', true, true)
export class UnconvertedInstrumentsWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, bindingEngine: BindingEngine, private unconvertedInstrumentsService: UnconvertedInstrumentsService,
    private cacheService: CacheService) {
    super(element, bindingEngine, customerService);
  }

  data: UnconvertedInstrumentsViewModel[];

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number = 25;

  @property('Text')
  color?: string;

  protected override async loadData(filter: IApplicationFilter): Promise<UnconvertedInstrumentsViewModel[]> {
    return this.cacheService.getOrSet(`unconverted-instruments-widget-${filter.customer.companyId}-${filter.dates.toStr}`,
      () => this.unconvertedInstrumentsService.getCached(filter.customer.companyId, false),
      60000, false);
  }

  protected override async setData(data: UnconvertedInstrumentsViewModel[]) {
    this.data = data;
    this.excelData = {
      fileName: 'Unconverted Instruments',
      data: { Items: data }
    };
  }
}
